// extracted by mini-css-extract-plugin
export default {"header":"QuestHeader-module--header--nBhsN","image":"QuestHeader-module--image--pE4o5"};